import { render } from "./Dashboard.pug?vue&type=template&id=22ba47ca&ts=true&lang=pug&external"
import script from "./Dashboard.ts?vue&type=script&lang=ts&external"
export * from "./Dashboard.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22ba47ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22ba47ca', __exports__)) {
    api.reload('22ba47ca', __exports__)
  }
  
  module.hot.accept("./Dashboard.pug?vue&type=template&id=22ba47ca&ts=true&lang=pug&external", () => {
    api.rerender('22ba47ca', render)
  })

}


export default __exports__